import React from "react";

import Form from '../FormContact/Form'

function Contact() {
    return (
        <>

            <div
                className="page-header section-dark"
                style={{
                    backgroundColor: '#4d4d4d',
                }} />

            <style>
                {".page-header {height: 80px; min-height: unset}"}
            </style>
            <Form />
        
        </>
    );
}

export default Contact;
